import * as React from 'react';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import LoginForm from './components/LoginForm';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { find, flow, get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IStore } from '../../../../redux/IStore';
import { FaSpinner } from 'react-icons/fa';
import { IAuthState } from '../../../../services/auth/models';
import { Link } from 'react-router-dom';
import * as queryString from 'query-string';

interface ILoginProps extends InjectedFormProps {
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  loginFailed: boolean;
  loginFailedCounter: number;
  auth: IAuthState;
  location: Location
}

class Login extends React.Component<ILoginProps> {

  private MAX_LOGIN_ATTEMPTS = 3;

  private handleSubmit = (formValues) => {
    const { actions, location } = this.props;
    const query = queryString.parse(location.search);
    return actions.auth.login(formValues.email, formValues.password, query.returnTo || '');
  }

  public render() {
    const { loginFailed, auth, loginFailedCounter } = this.props;
    const logInError = get(auth, 'error.login');
    const maxAttemptError = logInError ? find(logInError, ['detail', 'Max attempt reached']) : null;
    let maxAttempt = false;
    if (!isEmpty(maxAttemptError)) {
      maxAttempt = true;
    }

    return (
      <div className="page-container">
        <div className="customer-section-title login-form">

          <div>
            <div className={'login-form-title'}>Sign In</div>
            {!auth.hasPasswordBeenReset ? (
              <div>
                {loginFailed && loginFailedCounter < this.MAX_LOGIN_ATTEMPTS && (
                  <div className="login-failure">
                                     Your details do not match our records, please try again.
                                     If you have a policy with us, call us on 0333 234 9913 if the problem continues.
                                    </div>
                )}
                {loginFailed && loginFailedCounter >= this.MAX_LOGIN_ATTEMPTS && (
                  <div className="login-failure">
                                         Your details do not match our records, please try again, or reset your
                                        password <Link to="/auth/remind">here</Link>. If you have a policy with us,
                                        call us on 0333 234 9913 if the problem continues.
                                    </div>
                )}
                <LoginForm maxAttempt={maxAttempt} onSubmit={this.handleSubmit}/>
              </div>
            ) : (
              <div className="redirect white-card">
                <FaSpinner className="fa-spin spin-icon"/>
                <p>
                  You are now being redirected...
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'login',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      return {
        tripType,
        loginFailed: state.auth.loginFailed,
        loginFailedCounter: state.auth.loginFailedCounter,
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(Login);
